import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from "@angular/forms";
import { HttpService } from "../core/services/http.service";
import { ToastrTranslateService } from "../core/services/toastr-translate.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SettingsService, SettingsData } from "src/app/core/services/settings.service";
import { DataService } from "../core/services/data.service";
import { ProjectListService } from "../core/services/project-list/project-list.service";
import { CommonUtilService } from "../core/services/common-util-service";

@Component({
  selector: "app-add-asset-modal",
  templateUrl: "./add-asset-modal.component.html",
  styleUrls: ["./add-asset-modal.component.scss"],
})
export class AddAssetModalComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<boolean>();
  blockedPanel: boolean = false;
  dropdownAssetData: any = [];
  GLOBAL_COMPANY_ID = 123456789987;
  assetForm: FormGroup;
  assetId: any;
  assetDetail: any;

  fileExtension: any = null;
  fileName: string = null;

  profilePictureName: string;
  pictureUrl: string;
  allowedExtensionsForPhoto = ["pdf", "jpg", "png", "xlsx", "xlsm", "xlsb", "xltx", "docx", "dot", "dotx"];
  addedPictureNameMessage: string;
  invalidPhotoFormatError: string = null;
  removePhoto: boolean = false;
  public mask = [/[0-2]/, /[0-3]/, ":", /[0-5]/, /[0-9]/];
  modalHeading: string = "";
  settings: SettingsData = {};
  checkedURL: boolean = false;
  hideDelete: boolean = false;
  projectArr: any = [];
  selectedProject = null;
  assetOffset: number = 1;
  assetSize: number = 10;
  assetTotalCount: number = 0;
  filtersObj: any;
  assetList: any;
  rows = [];
  filteredProjects: any[] = [];
  assetModalTitle: string = "ADD ASSET";

  constructor(
    private settingsService: SettingsService,
    private projectService: ProjectListService,
    private httpService: HttpService,
    private formBuilder: FormBuilder,
    private router: Router,
    private dataService: DataService,
    private toastr: ToastrTranslateService,
    private route: ActivatedRoute,
    private commonUtilService: CommonUtilService
  ) {
    this.settings = this.settingsService.settings;
    this.assetForm = this.createAssetForm();
  }

  ngOnInit() {
    // this.blockedPanel = true;

    if (window.location.toString().includes("capital/edit-asset/")) {
      this.route.params.subscribe((params) => (this.assetId = params.id));
      this.dataService.checkSubmenu(this.router);
    }

    this.getDropDownAssetData();
    this.getAllProjectDataName();

    if (this.assetId != undefined) {
      this.modalHeading = "Edit Asset";
      this.hideDelete = true;
      this.getAssetById();
      this.blockedPanel = false;
    } else {
      this.modalHeading = "Add Asset";
      this.hideDelete = false;
      this.assetForm = this.createAssetForm();
      this.assetForm.controls["urlLink"].disable();
      this.blockedPanel = false;
    }
    this.setValidationOnDuration();

    this.assetForm.get("descriptionInfo.project")?.valueChanges.subscribe((val) => {
      if (!val) {
        this.filteredProjects = this.projectArr;
        this.assetForm.get("client")?.setValue("");
        return;
      }
      this.filteredProjects = this.projectArr.filter((p) => p.projectname.toLowerCase().includes(val.toLowerCase()));
      const selectedProject = this.projectArr.find((p) => p.projectname.toLowerCase() === val.toLowerCase());
      if (selectedProject) {
        this.getClientByProject(selectedProject.id);
      } else {
        this.assetForm.get("client")?.setValue("");
      }
    });
    // this.assetForm.get('urlLink').valueChanges.subscribe((value) => {
    //   this.assetForm.get('urlLink').setValidators(Validators.compose([Validators.required, Validators.pattern('(https://)([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?|(http://)([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]));

    // })
  }

  async getAllProjectDataName() {
    try {
      const resp: any = await this.projectService.getAllProjectDataName();
      this.projectArr = resp;
      this.filteredProjects = this.projectArr;
      if (window.location.toString().includes("project/project-booking/")) {
        this.selectedProject = null;
        this.route.params.subscribe((params) => (this.selectedProject = params.id));
        if (this.selectedProject) {
          let projectName = this.projectArr.findIndex((el) => el.id == this.selectedProject);
          if (projectName != -1) {
            this.assetForm.get("descriptionInfo").get("project").setValue(this.projectArr[projectName].projectname);
          }
        }
      }
    } catch (error) {}
  }

  setValidationOnDuration() {
    if (this.assetForm) {
      this.assetForm.get("duration").valueChanges.subscribe((value) => {
        let arr = value.split(":");
        let str = arr[0];
        let subStr = str.substr(0, 1);
        if (subStr == "2") this.mask = [/[0-2]/, /[0-3]/, ":", /[0-5]/, /[0-9]/];
        else this.mask = [/[0-2]/, /[0-9]/, ":", /[0-5]/, /[0-9]/];
      });
    }
  }

  createAssetForm() {
    return this.formBuilder.group({
      descriptionInfo: this.formBuilder.group({
        description: [null, Validators.required],
        project: [null],
      }),
      session: [null],
      episode: [null],
      duration: [null],
      client: [null],
      company: [null, Validators.required],
      avatar: [null],
      urlLink: [null],
      validate: [null],
    });
  }

  createAssetFormForEdit() {
    console.log("this.assetDetail ", this.assetDetail);
    this.blockedPanel = true;
    this.assetId = this.assetDetail.id || null;
    let projectId = this.assetDetail.recordId; // or wherever you store the project ID
    let projectObj = this.projectArr.find((el) => el.id === projectId);
    let projectName = projectObj ? projectObj.projectname : null;

    return this.formBuilder.group({
      descriptionInfo: this.formBuilder.group({
        description: [this.assetDetail.description, Validators.required],
        project: [this.assetDetail.projectName],
      }),
      session: [this.assetDetail.session],
      episode: [this.assetDetail.episode],
      duration: [this.assetDetail.duration],
      client: [this.assetDetail.clientName],
      year: [2020],
      company: [this.assetDetail.companyId, Validators.required],
      avatar: [null],
      urlLink: [this.assetDetail.url],
      validate: [null],
    });
  }

  getAssetById() {
    this.httpService.callApi("getAssetById", { pathVariable: this.assetId }).subscribe(
      (response) => {
        this.assetDetail = response;
        this.pictureUrl = this.assetDetail.thumbnail != null ? this.assetDetail.thumbnail.url : "";
        this.assetForm = this.createAssetFormForEdit();
        console.log("this is asset form details , while uploading ", this.assetForm);
        this.blockedPanel = false;
      },
      (error) => {
        this.blockedPanel = false;
        this.toastr.warning(error.error.message);
      }
    );
  }

  getDropDownAssetData() {
    this.blockedPanel = true;
    this.httpService.callApi("getAssetDropDownData", {}).subscribe(
      (response) => {
        this.blockedPanel = false;
        this.dropdownAssetData = response;
        this.dropdownAssetData.companies = this.dropdownAssetData.companies.filter((x) => x.id != this.GLOBAL_COMPANY_ID);
      },
      (error) => {
        this.blockedPanel = false;
        this.toastr.warning(error.error.message, "Asset");
      }
    );
  }

  getClientByProject(projectId: any) {
    if (projectId == "null") {
      this.assetForm.get("client").setValue("");
      return;
    }
    this.httpService.callApi("getClientNameForProject", { pathVariable: projectId }).subscribe(
      (resp) => {
        console.log("client name ", resp.name);
        this.assetForm.get("client").setValue(resp.name);
      },
      (error) => {
        this.blockedPanel = false;
        this.toastr.warning(error.error.message, "Asset");
      }
    );
  }

  getJSONToSaveAsset = () => {
    try {
      let assetForm = this.assetForm;
      console.log("this is asset form while saving", assetForm);
      if (assetForm.get("descriptionInfo").get("description").value == "" || assetForm.get("descriptionInfo").get("description").value == "undefined" || assetForm.get("descriptionInfo").get("description").value == null) {
        this.toastr.warning("please add description");
      }
      let projectName = assetForm.get("descriptionInfo").get("project").value || null;
      if (projectName == null || projectName == "") {
        return this.toastr.warning("Project Name is mandatory");
      }
      let recordId = this.projectArr.findIndex((el) => el.projectname.toLowerCase() == projectName.toLowerCase());
      if (recordId == -1) {
        return this.toastr.warning("Please select a valid Project.");
      }
      let assetData = {
        id: this.assetId || null,
        session: assetForm.get("session").value || null,
        description: assetForm.get("descriptionInfo").get("description").value || null,
        episode: assetForm.get("episode").value || null,
        duration: assetForm.get("duration").value || null,
        recordId: this.projectArr[recordId].id,
        companyId: assetForm.get("company").value || null,
        removePhoto: this.removePhoto || null,
        url: assetForm.get("urlLink").value || null,
      };
      console.log("this is asset data passing", assetData);
      return assetData;
    } catch (err) {}
  };

  hideAssetModal() {
    this.closeModalEvent.emit(false);
  }

  saveAsset() {
    this.blockedPanel = true;
    let body = this.getJSONToSaveAsset();
    console.log("this is asset form while updating", body);
    this.httpService.callApi("saveOrUpdateAsset", { body: body }).subscribe(
      (response) => {
        this.uploadPicture(response.id);
        this.getAllAssets();
        this.toastr.success("Saved");
        this.closeModalEvent.emit(false);
        this.blockedPanel = false;
      },
      (error) => {
        this.blockedPanel = false;
        this.toastr.warning(error.error.message);
      }
    );
  }

  async getAllAssets() {
    this.blockedPanel = true;
    try {
      let obj: any = {
        offset: this.assetOffset - 1,
        size: this.assetSize,
      };

      if (this.filtersObj != null) {
        obj = { ...this.filtersObj };
        delete obj["offset"];
        delete obj["size"];
      }
      const res: any = await this.commonUtilService.getAssetData(obj);
      const count: any = await this.commonUtilService.getAssetByStaffIdCount();
      this.assetTotalCount = count || 0;
      console.log(this.assetTotalCount);
      // Map the API response to match the table structure
      this.assetList = res || [];
      this.rows = this.assetList.map((asset) => {
        return {
          id: asset.id,
          thumbnail: asset.thumbnail ? asset.thumbnail.url : "/assets/img/demoImg.JPG",
          asset: asset.description,
          project: asset.projectName ? asset.projectName : "",
          client: asset.clientName,
          media: " ",
          show: "",
        };
      });
      this.blockedPanel = false;
      this.blockedPanel = false;
    } catch (error) {
      this.blockedPanel = false;
      console.log(error);
    }
  }

  /*-  To upload picture*/
  uploadPicture(personnelId: number) {
    this.blockedPanel = true;
    console.log(this.assetForm.get("avatar").value);
    if (this.assetForm.get("avatar").value) {
      let body = new FormData();
      body.append("discriminator", "asset");
      body.append("fileContent", this.assetForm.get("avatar").value);
      body.append("extension", this.fileExtension);
      body.append("fileName", this.fileName);
      this.httpService.callApi("uploadPicture", { body: body, pathVariable: personnelId }).subscribe(
        (respone) => {
          console.log("thumbnail uploaded sucessfully");
          this.getAllAssets();
          this.blockedPanel = false;
        },
        (error) => {
          this.blockedPanel = false;
        }
      );
    }
  }

  deleteAsset() {
    this.blockedPanel = true;
    if (this.assetId != undefined && this.assetId != null) {
      this.httpService.callApi("deleteAssetById", { pathVariable: this.assetId }).subscribe(
        (response) => {
          this.blockedPanel = false;
          this.hideAssetModal();
          this.router.navigate(["teamium/capital/asset"]);
          this.toastr.success("Successfully Deleted", "Asset");
        },
        (error) => {
          this.blockedPanel = false;
          this.toastr.warning(error.error.message);
        }
      );
    }
  }

  /*-  To handle event on  ProfilePictureChange*/
  onProfilePictureChange(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileExtension = file.name.split(".").pop().toLowerCase();
      this.fileExtension = file.name.split(".").pop().toLowerCase();
      this.fileName = file.name.split(".")[0];

      if (this.isInArray(this.allowedExtensionsForPhoto, fileExtension) && file.size < 2097152) {
        this.profilePictureName = file.name;
        this.addedPictureNameMessage = "Successfully added File:" + file.name;
        this.invalidPhotoFormatError = null;
        this.assetForm.get("avatar").setValue(file);
        var reader = new FileReader();

        reader.readAsDataURL(event.target.files[0]);

        reader.onload = (event) => {
          let target: any = event.target;
          this.pictureUrl = target.result;
        };
      } else if (file.size > 2097152) {
        this.profilePictureName = null;
        this.addedPictureNameMessage = null;
        this.assetForm.get("avatar").setValue(null);
        this.invalidPhotoFormatError = "File size should not be greater than 2MB.";
      } else {
        this.profilePictureName = null;
        this.addedPictureNameMessage = null;
        this.assetForm.get("avatar").setValue(null);
        this.invalidPhotoFormatError = "Only jpeg, jpg or png format allowed!!";
      }
    }
  }

  removePicture() {
    this.assetForm.get("avatar").setValue(null);
    this.pictureUrl = null;
    this.profilePictureName = "No file chosen";
    this.addedPictureNameMessage = null;
    this.removePhoto = true;
  }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onCheckboxChagen(event) {
    if (event.target.checked) {
      this.assetForm.controls["urlLink"].enable();
      this.checkedURL = true;
    } else {
      this.assetForm.controls["urlLink"].disable();
      this.checkedURL = false;
    }
  }
}
